export default __webpack_public_path__ + "static/media/gplus_logo_horizontal-06.5eb1e3e0.png";